import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { computed as t } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { getHours as A } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/getHours.js";
import { getMinutes as I } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/getMinutes.js";
import { getSeconds as M } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/getSeconds.js";
function j(s, r) {
  const l = t(() => {
    const {
      isTimeDisabled: i
    } = s, {
      value: e
    } = r;
    if (!(e === null || Array.isArray(e)))
      return i == null ? void 0 : i(e);
  }), d = t(() => {
    var i;
    return (i = l.value) === null || i === void 0 ? void 0 : i.isHourDisabled;
  }), o = t(() => {
    var i;
    return (i = l.value) === null || i === void 0 ? void 0 : i.isMinuteDisabled;
  }), v = t(() => {
    var i;
    return (i = l.value) === null || i === void 0 ? void 0 : i.isSecondDisabled;
  }), c = t(() => {
    const {
      type: i,
      isDateDisabled: e
    } = s, {
      value: a
    } = r;
    return a === null || Array.isArray(a) || !["date", "datetime"].includes(i) || !e ? !1 : e(a, {
      type: "input"
    });
  }), f = t(() => {
    const {
      type: i
    } = s, {
      value: e
    } = r;
    if (e === null || i === "datetime" || Array.isArray(e))
      return !1;
    const a = new Date(e), n = a.getHours(), u = a.getMinutes(), b = a.getMinutes();
    return (d.value ? d.value(n) : !1) || (o.value ? o.value(u, n) : !1) || (v.value ? v.value(b, u, n) : !1);
  }), D = t(() => c.value || f.value);
  return {
    // date & datetime
    isValueInvalidRef: t(() => {
      const {
        type: i
      } = s;
      return i === "date" ? c.value : i === "datetime" ? D.value : !1;
    }),
    isDateInvalidRef: c,
    // datetime only
    isTimeInvalidRef: f,
    isDateTimeInvalidRef: D,
    isHourDisabledRef: d,
    isMinuteDisabledRef: o,
    isSecondDisabledRef: v
  };
}
function k(s, r) {
  const l = t(() => {
    const {
      isTimeDisabled: e
    } = s, {
      value: a
    } = r;
    return !Array.isArray(a) || !e ? [void 0, void 0] : [e == null ? void 0 : e(a[0], "start", a), e == null ? void 0 : e(a[1], "end", a)];
  }), d = {
    isStartHourDisabledRef: t(() => {
      var e;
      return (e = l.value[0]) === null || e === void 0 ? void 0 : e.isHourDisabled;
    }),
    isEndHourDisabledRef: t(() => {
      var e;
      return (e = l.value[1]) === null || e === void 0 ? void 0 : e.isHourDisabled;
    }),
    isStartMinuteDisabledRef: t(() => {
      var e;
      return (e = l.value[0]) === null || e === void 0 ? void 0 : e.isMinuteDisabled;
    }),
    isEndMinuteDisabledRef: t(() => {
      var e;
      return (e = l.value[1]) === null || e === void 0 ? void 0 : e.isMinuteDisabled;
    }),
    isStartSecondDisabledRef: t(() => {
      var e;
      return (e = l.value[0]) === null || e === void 0 ? void 0 : e.isSecondDisabled;
    }),
    isEndSecondDisabledRef: t(() => {
      var e;
      return (e = l.value[1]) === null || e === void 0 ? void 0 : e.isSecondDisabled;
    })
  }, o = t(() => {
    const {
      type: e,
      isDateDisabled: a
    } = s, {
      value: n
    } = r;
    return n === null || !Array.isArray(n) || !["daterange", "datetimerange"].includes(e) || !a ? !1 : a(n[0], "start", n);
  }), v = t(() => {
    const {
      type: e,
      isDateDisabled: a
    } = s, {
      value: n
    } = r;
    return n === null || !Array.isArray(n) || !["daterange", "datetimerange"].includes(e) || !a ? !1 : a(n[1], "end", n);
  }), c = t(() => {
    const {
      type: e
    } = s, {
      value: a
    } = r;
    if (a === null || !Array.isArray(a) || e !== "datetimerange")
      return !1;
    const n = A(a[0]), u = I(a[0]), b = M(a[0]), {
      isStartHourDisabledRef: m,
      isStartMinuteDisabledRef: y,
      isStartSecondDisabledRef: R
    } = d;
    return (m.value ? m.value(n) : !1) || (y.value ? y.value(u, n) : !1) || (R.value ? R.value(b, u, n) : !1);
  }), f = t(() => {
    const {
      type: e
    } = s, {
      value: a
    } = r;
    if (a === null || !Array.isArray(a) || e !== "datetimerange")
      return !1;
    const n = A(a[1]), u = I(a[1]), b = M(a[1]), {
      isEndHourDisabledRef: m,
      isEndMinuteDisabledRef: y,
      isEndSecondDisabledRef: R
    } = d;
    return (m.value ? m.value(n) : !1) || (y.value ? y.value(u, n) : !1) || (R.value ? R.value(b, u, n) : !1);
  }), D = t(() => o.value || c.value), S = t(() => v.value || f.value), i = t(() => D.value || S.value);
  return Object.assign(Object.assign({}, d), {
    isStartDateInvalidRef: o,
    isEndDateInvalidRef: v,
    isStartTimeInvalidRef: c,
    isEndTimeInvalidRef: f,
    isStartValueInvalidRef: D,
    isEndValueInvalidRef: S,
    isRangeInvalidRef: i
  });
}
export {
  k as dualCalendarValidation,
  j as uniCalendarValidation
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/date-picker/src/validation-utils.js
// module id = 1675
// module chunks = 67